import {
    REPROCESS_ODOMETER_HOURS_REQUEST,
    REPROCESS_ODOMETER_HOURS_RESULT,
    REPROCESS_ODOMETER_HOURS_OPEN_MODAL,
    REPROCESS_ODOMETER_HOURS_CLOSE_MODAL,
    REPROCESS_ODOMETER_HOURS_GET_DEVICE_REQUEST,
    REPROCESS_ODOMETER_HOURS_GET_DEVICE_RESULT,
    REPROCESS_ODOMETER_HOURS_SET_DEVICE,
} from 'Redux/actionTypes';

export const reprocessOdoHoursRequest = (data) => ({
    type: REPROCESS_ODOMETER_HOURS_REQUEST,
    payload: data
})

export const reprocessOdoHoursResult = (result) => ({
    type: REPROCESS_ODOMETER_HOURS_RESULT,
    payload: result
})

export const reprocessOdoHoursOpenModal = (data) => ({
    type: REPROCESS_ODOMETER_HOURS_OPEN_MODAL,
    payload: data
})

export const reprocessOdoHoursCloseModal = () => ({
    type: REPROCESS_ODOMETER_HOURS_CLOSE_MODAL
})

export const reprocessOdoHoursGetDeviceRequest = (item, accountId) => ({
    type: REPROCESS_ODOMETER_HOURS_GET_DEVICE_REQUEST,
    payload: { devices: item, accountId: accountId }
})

export const reprocessOdoHoursGetDeviceResult = (result) => ({
    type: REPROCESS_ODOMETER_HOURS_GET_DEVICE_RESULT,
    payload: result
})

export const reprocessOdoHoursSetDevice = (device) => ({
    type: REPROCESS_ODOMETER_HOURS_SET_DEVICE,
    payload: device
})